<template>
  <div>
    <v-timeline-item hide-dot>
      <h4>{{ formatDateSimple(day.date) }}</h4>
    </v-timeline-item>
    <Event
      v-for="(event, idx) in day.events" :key="idx"
      :e="event"
      :icon="getIcon(event)"
      :iconColor="getIconColor(event)"
      :iconBackground="getBackgroundColor(isCaseTimeline)"
      :date-time-format="dateTimeFormat">
    </Event>
  </div>

</template>

<script>
import { lookupByEventType } from "@/stores/timeline/eventTypes"
import { mapState } from "vuex"
import Event from "@/components/timeline/Event"
import Helpers from '@/helpers.js'

export default {
  name: "TimelineDay",
  data: () => {
    return {

      timelineIcons: {
        "case.read": {
          icon: "visibility",
          iconColor: "blue"
        },
        "case.state.changed": {
          icon: "flare",
          iconColor: "error"
        },
        "case.updated": {
          icon: "cached",
          iconColor: "green"
        },
        "case.created": {
          icon: "note_add",
          iconColor: "yellow"
        },
        "task.created": {
          icon: "done",
          iconColor: "orange"
        },
        "tasklist.created": {
          icon: "done",
          iconColor: "orange"
        },
        "task.updated": {
          icon: "done",
          iconColor: "orange"
        },
        "task.executed": {
          icon: "done",
          iconColor: "orange"
        },
        "document.uploaded": {
          icon: "description",
          iconColor: "purple"
        },
        "document.updated": {
          icon: "description",
          iconColor: "purple"
        },
        "document.deleted": {
          icon: "description",
          iconColor: "purple"
        },
        "document.viewed": {
          icon: "description",
          iconColor: "purple"
        },
        "document.downloaded": {
          icon: "description",
          iconColor: "purple"
        },
        "document.duplicated": {
          icon: "description",
          iconColor: "purple"
        },
        "document.moved": {
          icon: "description",
          iconColor: "purple"
        },
        "document.copied": {
          icon: "description",
          iconColor: "purple"
        },
        "case.participant.added": {
          icon: "person",
          iconColor: "pink"
        },
        "case.participant.removed": {
          icon: "person",
          iconColor: "pink"
        },
        owner_changed: {
          icon: "person",
          iconColor: "pink"
        },
        default: {
          icon: "timeline",
          iconColor: "yellow"
        },
        "case.note.created": {
          icon: "note",
          iconColor: "brightBlue"
        },
        "case.note.updated": {
          icon: "note",
          iconColor: "brightBlue"
        },
        "case.note.deleted": {
          icon: "note",
          iconColor: "brightBlue"
        },
        "conversation.created": {
          icon: "chat",
          iconColor: "lightBlue"
        },
        "conversation.replied": {
          icon: "chat",
          iconColor: "lightBlue"
        },
        "conversation.read": {
          icon: "chat",
          iconColor: "lightBlue"
        },
        "conversation.attached": {
          icon: "chat",
          iconColor: "lightBlue"
        },
        "timeline.custom": {
          icon: "timeline",
          iconColor: "orange"
        },
        "bookmark.created": {
          icon: "bookmark",
          iconColor: "orange"
        },
        "bookmark.deleted": {
          icon: "bookmark_border",
          iconColor: "orange"
        },
        admin: {
          icon: "settings",
          iconColor: "yellow"
        }
      }
    }
  },
  props: {
    day: Object,
    isCaseTimeline: Boolean
  },
  methods: {
    iconEntry(event) {
      const icons = this.timelineIcons
      return lookupByEventType(icons, event && event.activity) || icons.default
    },
    getIcon(event) {
      return this.iconEntry(event).icon
    },
    getIconColor(event) {
      if (event && event.success === false) {
        return "error"
      }
      return this.iconEntry(event).iconColor
    },
    getBackgroundColor() {
      return this.isCaseTimeline ? "white" : "background"
    },
    formatDateSimple(date) {
      return Helpers.formatEventDateSimple(date)
    }
  },
  components: {
    Event
  },
  computed: {
    ...mapState({
      dateTimeFormat: state => state.currentUser.me.preferences.dateTimeFormat
    })
  }
}
</script>
